import { Countries } from "./Countries";
import { Currencies } from "./Currencies";

// ISO 3166-1 country → current ISO 4217 currency. Reference data: it is
// deliberately truthful (Japan → JPY, Croatia → EUR) even where the app
// does not support that currency; use supportedCurrencyForCountry() when you need
// a value the Currencies enum accepts. Keys are the app's Countries codes
// (note UK, not GB).
export const CountryCurrencies: Record<string, string> = {
  [Countries.UK]: "GBP",
  [Countries.AF]: "AFN",
  [Countries.AX]: "EUR",
  [Countries.AL]: "ALL",
  [Countries.DZ]: "DZD",
  [Countries.AS]: "USD",
  [Countries.AD]: "EUR",
  [Countries.AO]: "AOA",
  [Countries.AI]: "XCD",
  [Countries.AQ]: "USD",
  [Countries.AG]: "XCD",
  [Countries.AR]: "ARS",
  [Countries.AM]: "AMD",
  [Countries.AW]: "AWG",
  [Countries.AU]: "AUD",
  [Countries.AT]: "EUR",
  [Countries.AZ]: "AZN",
  [Countries.BS]: "BSD",
  [Countries.BH]: "BHD",
  [Countries.BD]: "BDT",
  [Countries.BB]: "BBD",
  [Countries.BY]: "BYN",
  [Countries.BE]: "EUR",
  [Countries.BZ]: "BZD",
  [Countries.BJ]: "XOF",
  [Countries.BM]: "BMD",
  [Countries.BT]: "BTN",
  [Countries.BO]: "BOB",
  [Countries.BQ]: "USD",
  [Countries.BA]: "BAM",
  [Countries.BW]: "BWP",
  [Countries.BV]: "NOK",
  [Countries.BR]: "BRL",
  [Countries.IO]: "USD",
  [Countries.BN]: "BND",
  [Countries.BG]: "EUR",
  [Countries.BF]: "XOF",
  [Countries.BI]: "BIF",
  [Countries.KH]: "KHR",
  [Countries.CM]: "XAF",
  [Countries.CA]: "CAD",
  [Countries.CV]: "CVE",
  [Countries.KY]: "KYD",
  [Countries.CF]: "XAF",
  [Countries.TD]: "XAF",
  [Countries.CL]: "CLP",
  [Countries.CN]: "CNY",
  [Countries.CX]: "AUD",
  [Countries.CC]: "AUD",
  [Countries.CO]: "COP",
  [Countries.KM]: "KMF",
  [Countries.CG]: "XAF",
  [Countries.CD]: "CDF",
  [Countries.CK]: "NZD",
  [Countries.CR]: "CRC",
  [Countries.CI]: "XOF",
  [Countries.HR]: "EUR",
  [Countries.CU]: "CUP",
  [Countries.CW]: "ANG",
  [Countries.CY]: "EUR",
  [Countries.CZ]: "CZK",
  [Countries.DK]: "DKK",
  [Countries.DJ]: "DJF",
  [Countries.DM]: "XCD",
  [Countries.DO]: "DOP",
  [Countries.EC]: "USD",
  [Countries.EG]: "EGP",
  [Countries.SV]: "USD",
  [Countries.GQ]: "XAF",
  [Countries.ER]: "ERN",
  [Countries.EE]: "EUR",
  [Countries.ET]: "ETB",
  [Countries.FK]: "FKP",
  [Countries.FO]: "DKK",
  [Countries.FJ]: "FJD",
  [Countries.FI]: "EUR",
  [Countries.FR]: "EUR",
  [Countries.GF]: "EUR",
  [Countries.PF]: "XPF",
  [Countries.TF]: "EUR",
  [Countries.GA]: "XAF",
  [Countries.GM]: "GMD",
  [Countries.GE]: "GEL",
  [Countries.DE]: "EUR",
  [Countries.GH]: "GHS",
  [Countries.GI]: "GIP",
  [Countries.GR]: "EUR",
  [Countries.GL]: "DKK",
  [Countries.GD]: "XCD",
  [Countries.GP]: "EUR",
  [Countries.GU]: "USD",
  [Countries.GT]: "GTQ",
  [Countries.GG]: "GBP",
  [Countries.GN]: "GNF",
  [Countries.GW]: "XOF",
  [Countries.GY]: "GYD",
  [Countries.HT]: "HTG",
  [Countries.HM]: "AUD",
  [Countries.VA]: "EUR",
  [Countries.HN]: "HNL",
  [Countries.HK]: "HKD",
  [Countries.HU]: "HUF",
  [Countries.IS]: "ISK",
  [Countries.IN]: "INR",
  [Countries.ID]: "IDR",
  [Countries.IR]: "IRR",
  [Countries.IQ]: "IQD",
  [Countries.IE]: "EUR",
  [Countries.IM]: "GBP",
  [Countries.IL]: "ILS",
  [Countries.IT]: "EUR",
  [Countries.JM]: "JMD",
  [Countries.JP]: "JPY",
  [Countries.JE]: "GBP",
  [Countries.JO]: "JOD",
  [Countries.KZ]: "KZT",
  [Countries.KE]: "KES",
  [Countries.KI]: "AUD",
  [Countries.KP]: "KPW",
  [Countries.KR]: "KRW",
  [Countries.XK]: "EUR",
  [Countries.KW]: "KWD",
  [Countries.KG]: "KGS",
  [Countries.LA]: "LAK",
  [Countries.LV]: "EUR",
  [Countries.LB]: "LBP",
  [Countries.LS]: "LSL",
  [Countries.LR]: "LRD",
  [Countries.LY]: "LYD",
  [Countries.LI]: "CHF",
  [Countries.LT]: "EUR",
  [Countries.LU]: "EUR",
  [Countries.MO]: "MOP",
  [Countries.MK]: "MKD",
  [Countries.MG]: "MGA",
  [Countries.MW]: "MWK",
  [Countries.MY]: "MYR",
  [Countries.MV]: "MVR",
  [Countries.ML]: "XOF",
  [Countries.MT]: "EUR",
  [Countries.MH]: "USD",
  [Countries.MQ]: "EUR",
  [Countries.MR]: "MRU",
  [Countries.MU]: "MUR",
  [Countries.YT]: "EUR",
  [Countries.MX]: "MXN",
  [Countries.FM]: "USD",
  [Countries.MD]: "MDL",
  [Countries.MC]: "EUR",
  [Countries.MN]: "MNT",
  [Countries.ME]: "EUR",
  [Countries.MS]: "XCD",
  [Countries.MA]: "MAD",
  [Countries.MZ]: "MZN",
  [Countries.MM]: "MMK",
  [Countries.NA]: "NAD",
  [Countries.NR]: "AUD",
  [Countries.NP]: "NPR",
  [Countries.NL]: "EUR",
  [Countries.AN]: "ANG",
  [Countries.NC]: "XPF",
  [Countries.NZ]: "NZD",
  [Countries.NI]: "NIO",
  [Countries.NE]: "XOF",
  [Countries.NG]: "NGN",
  [Countries.NU]: "NZD",
  [Countries.NF]: "AUD",
  [Countries.MP]: "USD",
  [Countries.NO]: "NOK",
  [Countries.OM]: "OMR",
  [Countries.PK]: "PKR",
  [Countries.PW]: "USD",
  [Countries.PS]: "ILS",
  [Countries.PA]: "PAB",
  [Countries.PG]: "PGK",
  [Countries.PY]: "PYG",
  [Countries.PE]: "PEN",
  [Countries.PH]: "PHP",
  [Countries.PN]: "NZD",
  [Countries.PL]: "PLN",
  [Countries.PT]: "EUR",
  [Countries.PR]: "USD",
  [Countries.QA]: "QAR",
  [Countries.RE]: "EUR",
  [Countries.RO]: "RON",
  [Countries.RU]: "RUB",
  [Countries.RW]: "RWF",
  [Countries.BL]: "EUR",
  [Countries.SH]: "SHP",
  [Countries.KN]: "XCD",
  [Countries.LC]: "XCD",
  [Countries.MF]: "EUR",
  [Countries.PM]: "EUR",
  [Countries.VC]: "XCD",
  [Countries.WS]: "WST",
  [Countries.SM]: "EUR",
  [Countries.ST]: "STN",
  [Countries.SA]: "SAR",
  [Countries.SN]: "XOF",
  [Countries.RS]: "RSD",
  [Countries.CS]: "RSD",
  [Countries.SC]: "SCR",
  [Countries.SL]: "SLE",
  [Countries.SG]: "SGD",
  [Countries.SX]: "ANG",
  [Countries.SK]: "EUR",
  [Countries.SI]: "EUR",
  [Countries.SB]: "SBD",
  [Countries.SO]: "SOS",
  [Countries.ZA]: "ZAR",
  [Countries.GS]: "GBP",
  [Countries.SS]: "SSP",
  [Countries.ES]: "EUR",
  [Countries.LK]: "LKR",
  [Countries.SD]: "SDG",
  [Countries.SR]: "SRD",
  [Countries.SJ]: "NOK",
  [Countries.SZ]: "SZL",
  [Countries.SE]: "SEK",
  [Countries.CH]: "CHF",
  [Countries.SY]: "SYP",
  [Countries.TW]: "TWD",
  [Countries.TJ]: "TJS",
  [Countries.TZ]: "TZS",
  [Countries.TH]: "THB",
  [Countries.TL]: "USD",
  [Countries.TG]: "XOF",
  [Countries.TK]: "NZD",
  [Countries.TO]: "TOP",
  [Countries.TT]: "TTD",
  [Countries.TN]: "TND",
  [Countries.TR]: "TRY",
  [Countries.TM]: "TMT",
  [Countries.TC]: "USD",
  [Countries.TV]: "AUD",
  [Countries.UG]: "UGX",
  [Countries.UA]: "UAH",
  [Countries.AE]: "AED",
  [Countries.US]: "USD",
  [Countries.UM]: "USD",
  [Countries.UY]: "UYU",
  [Countries.UZ]: "UZS",
  [Countries.VU]: "VUV",
  [Countries.VE]: "VES",
  [Countries.VN]: "VND",
  [Countries.VG]: "USD",
  [Countries.VI]: "USD",
  [Countries.WF]: "XPF",
  [Countries.EH]: "MAD",
  [Countries.YE]: "YER",
  [Countries.ZM]: "ZMW",
  [Countries.ZW]: "ZWG"
};

const SUPPORTED_CURRENCIES = new Set(Object.values(Currencies) as string[]);

// The country's currency when the app can charge in it, else null. Callers
// decide the fallback (the API uses GBP, the school model default).
export function supportedCurrencyForCountry(
  country: string | null | undefined
): string | null {
  if (!country) return null;
  const code = CountryCurrencies[country];
  return code && SUPPORTED_CURRENCIES.has(code) ? code : null;
}
